import { render, staticRenderFns } from "./openLottery.vue?vue&type=template&id=6d83ccde"
import script from "./openLottery.vue?vue&type=script&lang=js"
export * from "./openLottery.vue?vue&type=script&lang=js"
import style0 from "./openLottery.vue?vue&type=style&index=0&id=6d83ccde&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports